import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ListDealershipComponent } from './list-dealership/list-dealership.component';
import { CreateDealershipComponent } from './create-dealership/create-dealership.component';
import { ImportDealershipComponent } from './import-dealership/import-dealership.component';
import { ExportDealershipComponent } from './export-dealership/export-dealership.component';
import { UpdateDealershipComponent } from './update-dealership/update-dealership.component';
import { permissionGuard } from 'src/app/shared/guards/permission/permission.guard';
import { Permission } from 'src/app/shared/models/permission/permission-dto';

const routes: Routes = [
  {
    path: '',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_DEALERSHIP },
    component: ListDealershipComponent
  },
  {
    path: 'create',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_DEALERSHIP },
    component: CreateDealershipComponent
  },
  {
    path: 'import',
    canActivate: [permissionGuard],
    data: { permission: Permission.CREATE_DEALERSHIP },
    component: ImportDealershipComponent
  },
  {
    path: 'export',
    canActivate: [permissionGuard],
    data: { permission: Permission.LIST_DEALERSHIP },
    component: ExportDealershipComponent
  },
  {
    path: ':id/update',
    canActivate: [permissionGuard],
    data: { permission: Permission.UPDATE_DEALERSHIP },
    component: UpdateDealershipComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealershipRoutingModule {}
